import { FieldType } from '../../../types/Field.type';
import { getValueByPath } from '../../../types/utils';
export const PostalCode = {
    priority: 20,
    label: 'fields.common.address.postal_code.label',
    fallbackLabel: 'Postal code',
    mandatory: (payload, path) => true,
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    type: FieldType.String,
    mfValidation: {
        pathToValidation: 'address/postalCode',
        options: {
            country: { pathToValue: "../country" },
        },
    },
    trackFieldValueWithAnalytics: false,
};
function isApplicable(payload, path) {
    var _a, _b, _c, _d;
    const EXCLUDED_FLOWS = ['UPSELL_WEBSTORE_TO_KPOS', 'UPSELL_WEBSTORE_TO_ADS_MANAGER', 'UPSELL_WEBSTORE_TO_CONTENT_MANAGER'];
    const contractOnboardingTypeValue = (_b = (_a = payload.contract_onboarding_type) === null || _a === void 0 ? void 0 : _a.valueOf) === null || _b === void 0 ? void 0 : _b.call(_a);
    const isExcludedFlow = contractOnboardingTypeValue && EXCLUDED_FLOWS.includes(contractOnboardingTypeValue);
    const productChannelValue = (_d = (_c = getValueByPath(payload, 'business_information.product_channel')) === null || _c === void 0 ? void 0 : _c.valueOf) === null || _d === void 0 ? void 0 : _d.call(_c);
    const isProductChannelInStore = productChannelValue === 'IN_STORE';
    const isInStorePath = path === 'in_stores.address.postal_code';
    return !isExcludedFlow || (isProductChannelInStore && isInStorePath);
}
